import React from 'react'; 

const Header = () => {
  return <h1 id="header">POPZAHRA</h1>
}

export default Header;
